import { Popover, Table, Tooltip } from "antd";
import { UIRecommendationAPIService } from "../../services/api/UIRecommendationAPIService";
import { formatNumber, storeMeta } from "../../shared/utils";
import { EyeOutlined } from "@ant-design/icons";
import { useState } from "react";
import { trackingService } from "../../services/api/trackingService.js";
import { RatingReviews } from "./RatingReviews.js";
import { PricePerUnit } from "./PricePerUnit.js";
import { DeliveryTime } from "./DeliveryTime.js";

const ProductDesc = ({ dataSource = [], onClose, visitUrl }) => {
  if (dataSource && dataSource?.length === 0) {
    return <div>Loading...</div>;
  }
  const columnConfig = [
    { title: "Name", dataIndex: "name" },
    { title: "Value", dataIndex: "value" },
  ];

  const closePopOver = (event) => {
    event.stopPropagation();
    onClose();
  };
  const onVisit = (event) => {
    event.stopPropagation();
    window.open(visitUrl, "_blank", "noopener,noreferrer");
    onClose();
  };
  return (
    <>
      <Table
        columns={columnConfig.map((col) => ({
          title: col.title,
          dataIndex: col.dataIndex,
        }))}
        dataSource={dataSource}
        showHeader={false}
        pagination={false}
        size="small"
        footer={() => (
          <div
            className="flex justify-between gap-2"
            style={{ paddingTop: "8px" }}
          >
            <button onClick={closePopOver}>Close</button>
            <button
              onClick={onVisit}
              className="bg-black text-white px-3 py-[10px] rounded-lg text-[13px] font-medium"
            >
              Visit Store
            </button>
          </div>
        )}
      />
    </>
  );
};

export const ProductCardV2 = ({
  product,
  isHighlighted,
  sortOption,
  phoneNumber,
}) => {
  const {
    key = "",
    image = "",
    title = "",
    rating = 0,
    reviews = 0,
    store = "",
    price = 0,
    link = "",
    raw_title = "",
    unit = "",
    capacity_per_pack = 0,
    unit_price = 0,
    normalized_unit = "",
    delivery_details = "",
    stores = [],
  } = product || {};

  const [quickViewResponse, setQuickViewResponse] = useState([]);
  const [open, setOpen] = useState(false);
  const shouldShowPerUnitPrice =
    (capacity_per_pack !== 1 && normalized_unit !== "count") || (capacity_per_pack !== 1 && normalized_unit == "count");

  const stores2 = [
    {
      capacity_per_item: 1,
      capacity_per_pack: 1,
      extraction_confidence: 0.9,
      image:
        "https://i5.walmartimages.com/seo/Straight-Talk-Moto-G-Play-4G-2024-64GB-Blue-Prepaid-Smartphone-Locked-to-Straight-Talk_35062c9f-8662-4162-87e0-2c2ff95e3eb0.9279bf7dee7bb1986c833eaa075d7b2e.jpeg",
      items_per_pack: 1,
      key: "1FVI7GMMI941",
      link: "https://www.walmart.com/ip/Straight-Talk-Moto-G-Play-4G-2024-64GB-Blue-Prepaid-Smartphone-Locked-to-Straight-Talk/5243895448?classType=REGULAR&athbdg=L1103",
      normalized_unit: "count",
      parsed_unit: "each",
      parsed_unit_price: null,
      price: 29.88,
      rating: 4.3,
      raw_title:
        "Straight Talk Moto G Play 4G 2024, 64GB, Blue - Prepaid Smartphone [Locked to Straight Talk]",
      reviews: 3579,
      store: "Walmart",
      title: "Straight Talk Moto G Play 2024",
      unit: "count",
      unit_price: 29.88,
    },
    {
      capacity_per_item: 1,
      capacity_per_pack: 1,
      extraction_confidence: 0.9,
      image:
        "https://i5.walmartimages.com/seo/AT-T-Moto-G-Play-2024-64GB-Sapphire-Blue-Prepaid-Smartphone_38b60d43-55fb-40af-9088-adcc1611144c.77aa5edf688e43071f1837ccabd7564f.jpeg?odnHeight=180&odnWidth=180&odnBg=FFFFFF",
      items_per_pack: 1,
      key: "5I4SZG2O08HW",
      link: "https://www.walmart.com/ip/AT-T-Moto-G-Play-2024-64GB-Sapphire-Blue-Prepaid-Smartphone/5321123189?classType=REGULAR&athbdg=L1600",
      normalized_unit: "count",
      parsed_unit: "each",
      parsed_unit_price: null,
      price: 39.88,
      rating: 4.1,
      raw_title:
        "AT&amp;T Moto G Play 2024, 64GB, Sapphire Blue -Prepaid Smartphone",
      reviews: 1170,
      store: "Walmart",
      title: "AT&T Moto G Play 2024 Smartphone",
      unit: "count",
      unit_price: 39.88,
    },
  ];

  const getHighlightedColorText = () => {
    switch (sortOption) {
      case "bestValue":
        return {
          border: "border-teal-400",
          bg: "bg-teal-400",
          text: "🏆 Best Value",
        };
      case "topRated":
        return {
          border: "border-teal-400",
          bg: "bg-teal-400",
          text: "🌟 Top Rated",
        };
      case "priceLow":
        return {
          border: "border-teal-400",
          bg: "bg-teal-400",
          text: "💰 Budget",
        };
      default:
        return {
          border: "border-transparent",
          bg: "bg-transparent-400",
          text: "",
        };
    }
  };

  const getQuickViewData = async ({ rawTitle }) => {
    try {
      const response = await UIRecommendationAPIService.quickView({
        title: rawTitle,
      });
      setQuickViewResponse(response.features);
    } catch (error) {
      console.log(error);
    }
  };
  const handleQuickViewClick = (store) => {
    if (phoneNumber) {
      trackingService.trackProductQuickViewClick(phoneNumber, {
        product_id: key,
        product_title: title,
        store: store,
        price: price,
        link: link,
        sort_option: sortOption,
      });
    }
  };
  const handleProductClick = (store) => {
    // Don't prevent default - let the link open
    if (phoneNumber) {
      trackingService.trackProductClick(phoneNumber, {
        product_id: key,
        product_title: title,
        store: store,
        price: price,
        link: link,
        sort_option: sortOption,
      });
    }
  };

  const handleProductMultiClick = (storeData) => {
    // Don't prevent default - let the link open
    if (phoneNumber) {
      trackingService.trackProductClick(phoneNumber, {
        product_id: storeData?.key,
        product_title: storeData?.title,
        store: storeData?.store,
        price: storeData?.price,
        link: storeData?.link,
        sort_option: sortOption,
      });
    }
  };

  return (
    <div
      onClick={() => {
        if (stores.length === 0) {
          handleProductClick(store);
          window.open(link, "_blank", "noopener,noreferrer");
        }
      }}
      className={`
            cursor-pointer
            relative bg-white rounded-[12px]
            m-[5px] ml-0 flex flex-col
            w-[230px]
            sm:w-[230px]
            md:w-[260px]
            lg:w-[290px]
            flex-shrink-0
            border-2
            shadow-[0_2px_8px_rgba(0,0,0,0.12)]

            ${
              isHighlighted
                ? getHighlightedColorText()?.border
                : "border-transparent"
            }
          `}
    >
      {isHighlighted && (
        <div
          className={`${
            getHighlightedColorText()?.bg
          } rounded-t-lg items-center text-center text-xs py-0.5`}
        >
          {getHighlightedColorText()?.text}
        </div>
      )}
      {/* Product Image */}

      <div
        className={`px-[10px] pb-[10px] ${
          isHighlighted ? "pt-[2px]" : "pt-[20px]"
        }`}
      >
        <img
          src={image}
          alt="Product"
          className="w-full h-[150px] object-contain object-center rounded-lg"
        />

        {/* Product Title */}
        <Tooltip title={title} placement="top">
          <h3 className="mt-3 text-xs sm:text-sm text-gray-800 line-clamp-3 leading-snug h-[4.2em]">
            {title}
          </h3>
        </Tooltip>

        {/* Rating & Weight */}
        <div className="flex items-center justify-between mt-2 whitespace-nowrap">
          {rating > 0 ? (
            <RatingReviews rating={rating} reviews={reviews} />
          ) : (
            <div></div>
          )}

          <Popover
            title={
              <ProductDesc
                dataSource={quickViewResponse}
                onClose={() => setOpen(false)}
                visitUrl={link}
              />
            }
            placement="bottom"
            open={open}
            trigger={"click"}
            onOpenChange={setOpen}
          >
            <button
              onClick={(event) => {
                event.stopPropagation();
                getQuickViewData({ rawTitle: raw_title });
                handleQuickViewClick(store);
              }}
              className=" justify-center text-gray-500 border-gray-500 border text-[10px] sm:text-xs px-1.5 py-0.5 rounded-[10px] shrink-0 gap-1"
            >
              <EyeOutlined style={{ fontSize: 12 }} /> Quick view
            </button>
          </Popover>
        </div>

        {shouldShowPerUnitPrice && (
          <PricePerUnit unit={normalized_unit} unitPrice={unit_price} />
        )}

        {stores?.length > 0 ? (
          stores?.map((storeData, index) => {
            return (
              <div
                className={`border-t border-gray-100 ${
                  index === 0 ? "mt-4" : ""
                }`}
              >
                <div className="flex items-center justify-between pt-2">
                  <div className="pr-2 flex-1 ">
                    <div className="flex gap-2 min-w-0">
                      <img
                        src={storeMeta[storeData?.store]?.logo}
                        alt={storeData?.store}
                        className="hidden md:block w-4 h-4 object-contain"
                      />
                      <p className="text-xs font-medium text-gray-800 truncate">
                        {storeData?.store}
                      </p>

                      <p className="text-xs font-semibold text-gray-900 ml-auto">
                        ${storeData?.price.toFixed(2)}
                      </p>
                    </div>
                  </div>

                  <div className="flex shrink-0 ">
                    <button
                      onClick={(event) => {
                        // handleProductClick(store)
                        handleProductMultiClick(storeData);
                        window.open(
                          storeData?.link,
                          "_blank",
                          "noopener,noreferrer"
                        );
                      }}
                      className="
                    px-3 py-[5px]
                    text-[13px] font-medium
                    rounded-lg
                    bg-black text-white"
                    >
                      Visit Store
                    </button>
                  </div>
                </div>
                <div className="pb-3">
                  <DeliveryTime
                    delivery_details={storeData?.delivery_details}
                  />
                </div>
              </div>
            );
          })
        ) : (
          <div className="mt-4 border-t border-gray-100">
            <div className="flex items-center justify-between">
              <div className="mr-1 flex-1">
                <div className="flex items-center gap-2 min-w-0 ">
                  <img
                    src={storeMeta[store]?.logo}
                    alt={store}
                    className="hidden md:block w-4 h-4 object-contain"
                  />
                  <p className="text-xs font-medium text-gray-800 truncate">
                    {store}
                  </p>
                  <p className="text-xs font-semibold text-gray-900 ml-auto">
                    ${price.toFixed(2)}
                  </p>
                </div>
              </div>

              <div className="flex shrink-0 py-1">
                <button
                  onClick={(event) => {
                    handleProductClick(store);
                    window.open(link, "_blank", "noopener,noreferrer");
                  }}
                  className="
                    px-3 py-[5px]
                    text-[13px] font-medium
                    rounded-lg
                    bg-black text-white"
                >
                  Visit Store
                </button>
              </div>
            </div>

            <div className="pb-3">
              <DeliveryTime delivery_details={delivery_details} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
